import React, { useContext } from "react"
import { postToTable } from "../api/apiCalls"
import { Grid } from "@material-ui/core"
import PropTypes from "prop-types"
import MenuCard from "./MenuCard"
import { SchemaContext } from "../contexts/SchemaContext"
import ActivityFeedCard from "../components/ActivityFeedCard"
import { HistoryContext } from "../contexts/HistoryContext"
import { UserContext } from "../contexts/UserContext"

const SRFMenu = ({ onSelect }) => {
  const { user } = useContext(UserContext)
  const { accessLevel } = user
  const { schema } = useContext(SchemaContext)

  const { fetchHistory, history, historyLoading, historyError } = useContext(
    HistoryContext
  )

  const reload = () => {
    fetchHistory(user)
  }

  const standards = schema.filter(
    (button) => button.button_type_id === 1 && !button.upload
  )
  const factors = schema.filter((button) => button.button_type_id === 2)
  const standardsUploads = schema.filter(
    (button) => button.button_type_id === 1 && button.upload
  )
  const standardsDownloads = schema.filter(
    (button) => button.button_type_id === 1 && button.download
  )

  console.log(" STANDARDS DOWNLOADS ", standardsDownloads)

  const uploadHistory = history.filter(
    (item) =>
      item.activity_type_id === 1 ||
      (item.activity_type_id === 2 && item.context !== "megafile") ||
      item.activity_type_id === 8 ||
      item.activity_type_id === 10 ||
      item.activity_type_id === 11
  )

  const saveActivity = (user, file, uploaded = true, context = null) => {
    let activity = uploaded ? 1 : 2
    postToTable(user, "history", {
      user: user.name ? user.name : user.email,
      user_email: user.email,
      activity_type_id: activity,
      filename: file,
      context,
    })
    // save activity to db? or in backend
  }

  return (
    <Grid container>
      <Grid md={6}>
        <Grid md={10}>
          <MenuCard
            title="Standards"
            options={standards}
            uploads={
              accessLevel === "ADMIN" || accessLevel === "USER"
                ? standardsUploads
                : []
            }
            downloads={
              accessLevel === "ADMIN" || accessLevel === "USER"
                ? standardsDownloads
                : []
            }
            onSelect={onSelect}
            saveActivity={saveActivity}
          />
          <MenuCard
            title="Factors"
            options={factors}
            onSelect={onSelect}
            saveActivity={saveActivity}
          />
        </Grid>
      </Grid>
      <Grid md={6}>
        <Grid md={10}>
          <ActivityFeedCard
            title="Upload Activity"
            activities={uploadHistory}
            loading={historyLoading}
            error={historyError}
            refreshHistory={reload}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

SRFMenu.propTypes = {
  onSelect: PropTypes.func,
}

export default SRFMenu
